import { useEffect, useState } from "react";
import { footerLinks } from "@/mocks/civicData";

export default function Footer() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <footer className="bg-background-100">
      <div className="border-t border-primary-200 bg-primary-50 px-4 py-14 md:px-6">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 lg:flex-row">
          <div className="max-w-xl text-center lg:text-left">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              让善意，落在对的地方
            </h2>
            <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-base">
              用依法、理性、客观的方式参与共治，让身边的问题被及时看见与处理。
            </p>
          </div>
          <a
            href="#guide"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-base font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            查看反映指南
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-sun-line text-xl" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                朝阳群众 · 线索指南
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-7 text-foreground-600">
              本页面为公民参与公共监督的信息指引，帮助读者了解向公安机关与政府部门正规反映线索的渠道与方式。线索反映请以属地官方渠道为准，紧急情况请立即报警求助。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-foreground-900">
              快速导航
            </h3>
            <ul className="mt-4 space-y-3">
              {footerLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-foreground-900">
              重要提示
            </h3>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-phone-fill mt-0.5 text-primary-500"></i>
                紧急警情：请立即拨打报警电话
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-customer-service-2-line mt-0.5 text-accent-500"></i>
                政务服务：可拨打 12345 政务服务便民热线
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-lock-2-line mt-0.5 text-secondary-500"></i>
                官方渠道提交，个人信息依法保密
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 朝阳群众线索指南 · 内容仅供信息参考
          </p>
          <p className="text-xs text-foreground-500">
            依法反映 · 理性参与 · 共建平安家园
          </p>
        </div>
      </div>

      <a
        href="#home"
        aria-label="返回顶部"
        className={`fixed bottom-6 right-6 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-all duration-300 hover:bg-primary-600 ${
          showTop ? "opacity-100" : "pointer-events-none opacity-0"
        }`}
      >
        <i className="ri-arrow-up-line text-xl"></i>
      </a>
    </footer>
  );
}